import React from 'react';
import { ARI_GLASS, ARI_BOLT } from '../lib/ariArt';

/* The landing-page orb, shrunk for in-app use. Same glass sphere, same
   beating electric heart - the orb stays still, the heart beats.
   `thinking` speeds the beat up while Ari is composing a reply. */
export const AriOrb = ({ size = 56, thinking = false, className = '' }) => (
  <span
    className={`relative inline-block shrink-0 ${thinking ? 'alt-thinking' : ''} ${className}`}
    style={{ width: size, height: size }}
    data-testid="ari-orb"
  >
    <span
      className="absolute inset-[10%] rounded-full blur-[10px] alt-orb-core"
      style={{ background: 'rgb(37 99 235 / 0.45)' }}
    />
    <img
      src={ARI_GLASS}
      alt=""
      aria-hidden="true"
      className="absolute inset-0 w-full h-full object-contain alt-emblem-mask select-none"
      draggable="false"
    />
    <img
      src={ARI_BOLT}
      alt=""
      aria-hidden="true"
      className="absolute inset-[20%] w-[60%] h-[60%] object-contain alt-screen alt-heart-mask alt-heartbeat select-none"
      draggable="false"
    />
  </span>
);

export default AriOrb;
